export const GAP_PX = 4;
export const VIEWPORT_PAD_PX = 10;
export const MIN_SCROLLABLE_H = 160;
export const FALLBACK_TOOLTIP_H = 440;
export const TOOLTIP_PORTAL_Z_INDEX = 200050;

export function computeHoverPanelHorizontal(trig, viewportWidth) {
  let left = 0;
  let transform = "none";

  if (viewportWidth < 768) {
    if (trig.left < viewportWidth / 3) {
      left = 0;
    } else if (
      trig.left >= viewportWidth / 3 &&
      trig.left < (2 * viewportWidth) / 3
    ) {
      left = "50%";
      transform = "translateX(-50%)";
    } else {
      left = viewportWidth;
      transform = "translateX(-100%)";
    }
  } else {
    if (trig.left <= viewportWidth / 2) {
      left = `${trig.left}px`;
      transform = "none";
    } else {
      left = `${trig.right}px`;
      transform = "translateX(-100%)";
    }
  }

  return { left, transform };
}

/** @param {(partial: Record<string, string | number | undefined>) => void} setter */
export function setTooltipPackIfChanged(packRef, setter, partial) {
  const maxH = partial.maxHeight;
  const pack = `${partial.top}|${partial.left}|${String(partial.transform)}|${maxH ?? ""}`;
  if (packRef.current === pack) return;
  packRef.current = pack;
  setter({
    position: "fixed",
    zIndex: TOOLTIP_PORTAL_Z_INDEX,
    boxSizing: "border-box",
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    top: partial.top,
    left: partial.left,
    transform: partial.transform,
    ...(typeof maxH === "number"
      ? {
          maxHeight: maxH,
          overflowY: "auto",
          overscrollBehavior: "contain",
        }
      : {}),
  });
}

export function computeVerticalPlacement(trig, tooltipH, viewportHeight) {
  const belowTop = trig.bottom + GAP_PX;
  const spaceBelow = viewportHeight - VIEWPORT_PAD_PX - belowTop;
  const aboveTopCandidate = trig.top - GAP_PX - tooltipH;
  const spaceAbove = trig.top - GAP_PX - VIEWPORT_PAD_PX;

  /** @type {number | undefined} */
  let maxHeight;
  let top;

  if (tooltipH <= spaceBelow) {
    top = belowTop;
  } else if (tooltipH <= spaceAbove && aboveTopCandidate >= VIEWPORT_PAD_PX) {
    top = aboveTopCandidate;
  } else {
    const preferBelow =
      spaceBelow >= Math.max(spaceAbove, MIN_SCROLLABLE_H * 0.25);
    if (preferBelow) {
      top = belowTop;
      maxHeight = spaceBelow;
    } else {
      maxHeight = spaceAbove;
      top = trig.top - GAP_PX - maxHeight;
    }
    maxHeight = Math.max(
      MIN_SCROLLABLE_H,
      Math.min(maxHeight, viewportHeight - 2 * VIEWPORT_PAD_PX)
    );
    top = Math.min(
      top,
      viewportHeight - VIEWPORT_PAD_PX - maxHeight
    );
    top = Math.max(VIEWPORT_PAD_PX, top);
  }

  return { top, maxHeight };
}
